/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getDarkBorderVertical, removeHex } from '../../lib/utils';

import * as AppPropTypes from '../../lib/PropTypes';
import Menu from './Menu';

import styles from '../../../styles/menus/mobile.scss';

const propTypes = {
    topItems: AppPropTypes.menuItems,
    bottomItems: AppPropTypes.menuItems,
    color: AppPropTypes.color,
    theme: PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.object, // eslint-disable-line
    className: PropTypes.string,
};

const defaultProps = {
    topItems: [],
    bottomItems: [],
    color: null,
    theme: null,
    onClick: null,
    style: null,
    className: null,
};

const MobileMenu = ({ topItems, bottomItems, color, theme, onClick, style, className }) => {
    const borderPath = getDarkBorderVertical(removeHex(color));
    return (
        <nav
            className={classNames([
                styles.container,
                {
                    [styles[theme]]: theme !== null,
                    [className]: className !== null,
                },
            ])}
            style={style}
        >
            <div style={{ backgroundImage: borderPath }} className={styles.raggedBorder} />
            <ul className={styles.items}>
                <Menu items={topItems} color={color} theme={theme} onClick={onClick} />
                <Menu
                    className={styles.bottom}
                    items={bottomItems}
                    color={color}
                    theme={theme}
                    hasReturn
                />
            </ul>
        </nav>
    );
};

MobileMenu.propTypes = propTypes;
MobileMenu.defaultProps = defaultProps;

export default MobileMenu;
